import {MainMenuApiModel} from "./main-menu.api-model";
import {BaseDomainModel} from "../../../../infrastructure/models/base-domain-model";

export class MainMenuDomainModel extends BaseDomainModel {
  apiModel: MainMenuApiModel;

  constructor(apiModel: MainMenuApiModel) {
    super(apiModel);

    this.label = apiModel.label;
    this.alt = apiModel.alt;
    this.linkLabel = apiModel.linkLabel;
    this.url = apiModel.url;
    this.icon = apiModel.icon;
    this.items = apiModel.items ? apiModel.items.map(item => new MainMenuDomainModel(item)) : null;
  }
}
